<div class="layout">
  @if (showSideBar) { @if (!isMobile || (isMobile && isSidebarExpanded)) {
  <!-- Main Sidebar -->
  <aside
    class="sidebar d-flex flex-column align-items-center position-relative"
    *ngIf="showSideBar && (!isMobile || (isMobile && isSidebarExpanded))"
    [ngClass]="{ expanded: isSidebarExpanded }"
    (click)="$event.stopPropagation()"
    (keydown)="toggleSidebar($event)"
    tabindex="0">
    <button (click)="toggleSidebar()" class="bg-none border-0" tabindex="0" (keydown)="toggleSidebar($event)">
      @if(isMobile) {
      <span [innerHtml]="SVG_ICONS.MENU_ICON() | sanitizer : 'html'"></span>
      } @else {
      <img [src]="isSidebarExpanded ? 'public/spartan-logo.png' : 'public/spartan.png'" alt="Spartan Logo" class="mt-3" />
      }
    </button>

    <ul class="list-style-none p-0 w-100 mt-4 d-flex flex-column gap-2" [ngClass]="{ 'align-items-center': !isSidebarExpanded, 'ms-3': isSidebarExpanded }">
      <li
        *ngFor="let menu of userMenus"
        class="nav-item"
        [ngClass]="{
          'font-white': hoveredItem === menu.MenuName || isRouteActive(menu.RouterPath) || selectedParentMenu?.MenuID === menu.MenuID,
          active: (isRouteActive(menu.RouterPath) && menu.children.length === 0) || selectedParentMenu?.MenuID === menu.MenuID,
          'has-children': menu.children.length > 0,
          'flex-column align-items-start': isMobile && menu.children.length > 0
        }"
        (mouseenter)="hoveredItem = menu.MenuName"
        (mouseleave)="hoveredItem = null"
        (click)="onMenuClick(menu, $event)"
        (keydown.enter)="onMenuClick(menu, $event)"
        (keydown.space)="onMenuClick(menu, $event)"
        tabindex="0">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center gap-2">
            <div
              *ngIf="menu.Svg_Default"
              class="icon"
              [ngClass]="{
                'svg-white': hoveredItem === menu.MenuName || isRouteActive(menu.RouterPath) || selectedParentMenu?.MenuID === menu.MenuID,
                'svg-default': hoveredItem !== menu.MenuName && !isRouteActive(menu.RouterPath) && selectedParentMenu?.MenuID !== menu.MenuID
              }"
              [innerHtml]="menu.Svg_Default | sanitizer : 'html'"></div>

            <span
              *ngIf="isSidebarExpanded"
              class="fs-14 fw-normal"
              [ngClass]="{
                'font-white': hoveredItem === menu.MenuName || isRouteActive(menu.RouterPath) || selectedParentMenu?.MenuID === menu.MenuID,
                'font-gray-opacity': hoveredItem !== menu.MenuName && !isRouteActive(menu.RouterPath) && selectedParentMenu?.MenuID !== menu.MenuID
              }">
              {{ menu.MenuName }}
            </span>
          </div>

          <!-- Arrow icon for parent menus -->
          <span *ngIf="isSidebarExpanded && menu.children.length > 0" class="expand-arrow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" [style.transform]="selectedParentMenu?.MenuID === menu.MenuID ? 'rotate(180deg)' : 'rotate(0deg)'">
              <path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>

        <!-- Mobile Child Menu (Accordion) -->
        @if(isMobile && selectedParentMenu?.MenuID === menu.MenuID && menu.children.length > 0) {
        <ul class="list-style-none p-0 w-100 mt-2 mobile-child-menu" style="list-style: none">
          <li
            *ngFor="let child of menu.children"
            class="child-menu-item cursor-pointer ps-4 py-2 border-radius-5"
            [ngClass]="{ active: isRouteActive(menu.RouterPath + child.RouterPath) }"
            (click)="onChildMenuClick(child, menu.RouterPath, $event)"
            tabindex="0">
            <div class="d-flex align-items-center gap-2">
              <div *ngIf="child.Svg_Default" class="child-icon" style="width: 20px; height: 20px" [innerHtml]="child.Svg_Default | sanitizer : 'html'"></div>
              <span class="fs-13 font-gray-opacity" [ngClass]="{ 'font-white': isRouteActive(child.RouterPath) }">{{ child.MenuName }}</span>
            </div>
          </li>
        </ul>
        }
      </li>
    </ul>
  </aside>
  @if(!isMobile && selectedParentMenu && selectedParentMenu.children.length > 0) {
  <div class="child">
    <div
      class="child-menu-bar"
      (click)="$event.stopPropagation()"
      tabindex="0"
      (keydown.enter)="onChildMenuClick(selectedParentMenu.children[0], selectedParentMenu.RouterPath, $event)"
      (keydown.space)="onChildMenuClick(selectedParentMenu.children[0], selectedParentMenu.RouterPath, $event)">
      <ul class="list-style-none p-0 m-0">
        <li
          *ngFor="let child of selectedParentMenu.children"
          class="child-menu-item cursor-pointer"
          [ngClass]="{ active: isRouteActive(selectedParentMenu.RouterPath + child.RouterPath) }"
          (click)="onChildMenuClick(child, selectedParentMenu.RouterPath, $event)"
          tabindex="0"
          (keydown.enter)="onChildMenuClick(child, selectedParentMenu.RouterPath, $event)"
          (keydown.space)="onChildMenuClick(child, selectedParentMenu.RouterPath, $event)">
          <div class="child-menu-content">
            <div *ngIf="child.Svg_Default" class="child-icon" [innerHtml]="child.Svg_Default | sanitizer : 'html'"></div>
            <span class="child-menu-name">{{ child.MenuName }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  }
  <!-- Child Menu Bar (Red area in your image) -->
  } }

  <!-- Mobile Backdrop -->
  <div class="mobile-backdrop" *ngIf="isMobile && isSidebarExpanded" (click)="toggleSidebar()"></div>

  <!-- Main Content Area (Blue area in your image) -->
  <div class="flex-fill position-relative bg-white d-flex flex-column" [ngClass]="{ 'with-child-menu': selectedParentMenu && selectedParentMenu.children.length > 0 }">
    <div class="navbar-top position-relative d-flex align-items-center w-100" *ngIf="!isLoginPage">
      @if (isMobile) {
      <div class="d-flex flex-column w-100">
        <!-- Row 1: Logo & Profile/Menu -->
        <div class="d-flex align-items-center justify-content-between w-100">
          <!-- Left: Logo -->

          <div class="d-flex align-items-center gap-2">
            @if(isLoggedIn && router.url !== '/center-select-page') {
            <button class="bg-none border-0 p-0 d-flex align-items-center" (click)="toggleSidebar()" tabindex="0">
              <span [innerHtml]="SVG_ICONS.MENU_ICON() | sanitizer : 'html'" class="font-white"></span>
            </button>
            }

            <div class="d-flex align-items-center gap-2">
              <img src="public/spartan-logo.png" routerLink="/center-select-page" alt="Spartan Logo" style="height: 35px; object-fit: contain" />
            </div>
          </div>

          <!-- Right: Profile & Menu -->
          <div class="d-flex align-items-center gap-3">
            @if(isLoggedIn) {
            <div class="position-relative" (click)="toggleProfileDropdown($event)">
              <div class="d-flex align-items-center gap-2 cursor-pointer">
                <img [src]="profileImage" alt="profile" class="profile-img border-radius-50 object-fit-cover" style="width: 35px; height: 35px; border: 2px solid white" (error)="onImgError($event)" />

                <div class="d-flex flex-column">
                  <span class="font-white fs-14 fw-bold">{{ userDetails?.TrainerName }} {{ userDetails?.TrainerLastName || "" }}</span>
                  <span class="font-white fs-12" style="opacity: 0.8">{{ userDetails?.Email || "" }}</span>
                </div>
              </div>

              @if(isProfileDropdownOpen) {
              <div
                class="position-absolute top-100 end-0 bg-white border border-radius-10 mt-2 py-2 shadow profile-dropdown"
                style="min-width: 120px; z-index: 1050"
                (click)="$event.stopPropagation()">
                <button class="dropdown-item px-3 py-2 d-block text-dark cursor-pointer w-100 text-start" (click)="logout()" type="button">Logout</button>
              </div>
              }
            </div>
            }
          </div>
        </div>

        <!-- Row 2: Center Select & Create -->
        @if(isLoggedIn && router.url !== '/center-select-page') {
        <div class="d-flex align-items-center justify-content-between w-100 mt-3">
          <!-- Center Selector -->
          <div
            class="position-relative d-flex align-items-center gap-2 border-radius-5 px-2 py-1 cursor-pointer"
            style="max-width: 65%; border: 1px solid rgba(255, 255, 255, 0.3)"
            (click)="togglePopup($event)">
            <div class="d-flex flex-column overflow-hidden">
              <div class="fs-14 fw-semibold font-white text-truncate">{{ centerDetails?.CenterName }}</div>
              <small class="fs-12 font-white text-truncate" style="opacity: 0.8">{{ centerDetails?.Address }}</small>
            </div>
            <button class="down-arrow bg-transparent border-0 p-0 d-flex align-items-center" [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'"></button>

            @if(showPopup) {
            <div class="custom-popup border-radius-10 fs-14 d-flex flex-column overflow-hidden" style="top: 100%; left: 0; width: 280px" (click)="$event.stopPropagation()">
              <div class="popup-list">
                <label class="popup-item select-all p-2 cursor-pointer d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    class="form-check-input border-radius-5 cursor-pointer"
                    [checked]="selectedCenterIds.length === centerList.length && centerList.length > 0"
                    (change)="toggleSelectAll($event)" />
                  <div class="fw-bold">Select All</div>
                </label>

                @for(center of centerList; track center.CenterID) {
                <label class="popup-item p-2 cursor-pointer d-flex align-items-center gap-2">
                  <input type="checkbox" [checked]="isSelected(center)" (change)="onCenterSelectionChange($event, center)" class="form-check-input border-radius-5 cursor-pointer" />
                  <div>
                    <div class="fw-semibold">{{ center.CenterName }} ({{ center.State }})</div>
                    <!-- <div class="fs-12">{{ center.Address }}</div> -->
                  </div>
                </label>
                }
              </div>
              <div class="popup-actions p-3 text-end">
                <button class="btn btn-primary btn-sm" (click)="applySelection()">Apply</button>
              </div>
            </div>
            }
          </div>

          <!-- Create Button -->
          <div class="position-relative">
            <button class="create-btn d-flex align-items-center gap-2" (click)="toggleDropdown($event)">
              Create
              <span [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'"></span>
            </button>

            @if (isDropdownOpen) {
            <div class="dropdown-box position-absolute z-2 border-radius-10 shadow mt-2" style="right: 0; left: auto; width: 200px; top: 100%" (click)="$event.stopPropagation()">
              <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('student/add-student')">
                <span [innerHtml]="SVG_ICONS.ADD_MEMBER_ICON() | sanitizer : 'html'"></span>
                Add Student
              </button>
              @if(userTypeID === 1 || userTypeID === 2) {
              <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('coach/add-coach')">
                <span [innerHtml]="SVG_ICONS.CLASS_ICON('#F5F5F5') | sanitizer : 'html'"></span>
                Add Coach
              </button>
              }
              <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('class-list/add-class')">
                <span [innerHtml]="SVG_ICONS.CREATE_CLASS_ICON() | sanitizer : 'html'"></span>
                Create Class
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="col-6 d-flex justify-content-between">
        <div class="d-flex align-items-center gap-2 ms-0 ms-sm-3 ms-md-5">
          @if (showSideBar) { @if (isMobile) {
          <button class="bg-none border-0" (click)="toggleSidebar()" (keydown)="toggleSidebar($event)" tabindex="0">
            <span [innerHtml]="SVG_ICONS.MENU_ICON() | sanitizer : 'html'"></span>
          </button>
          }

          <div [innerHtml]="SVG_ICONS.HOME_ICON() | sanitizer : 'html'"></div>
          <div class="position-relative d-flex align-items-center gap-2">
            <div>
              <div class="fs-14 fw-semibold font-white">{{ centerDetails?.CenterName }}</div>
              <!-- <small class="fs-12 font-white truncate-line overflow-hidden text-overflow-ellipsis">
                {{ centerDetails?.Address }}
              </small> -->
            </div>

            <button
              (click)="togglePopup($event)"
              class="down-arrow bg-transparent border-0 p-0"
              [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'"
              (keydown.enter)="togglePopup($event)"
              (keydown.space)="togglePopup($event); $event.preventDefault()"
              [attr.aria-expanded]="showPopup"
              [attr.aria-haspopup]="true"
              [attr.aria-controls]="'center-selection-popup'"
              tabindex="0">
              <span class="sr-only">Toggle center selection</span>
            </button>

            @if(showPopup) {
            <div
              id="center-selection-popup"
              class="custom-popup border-radius-10 fs-14 d-flex flex-column overflow-hidden"
              (click)="$event.stopPropagation()"
              role="dialog"
              aria-label="Select Centers"
              tabindex="-1"
              (keydown.esc)="showPopup = false">
              <div class="popup-list">
                <label class="popup-item select-all p-2 cursor-pointer d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    class="form-check-input border-radius-5 cursor-pointer"
                    [checked]="selectedCenterIds.length === centerList.length && centerList.length > 0"
                    (change)="toggleSelectAll($event)" />
                  <div class="fw-bold">Select All</div>
                </label>

                @for(center of centerList; track center.CenterID) {
                <label class="popup-item p-2 cursor-pointer d-flex align-items-center gap-2">
                  <input type="checkbox" [checked]="isSelected(center)" (change)="onCenterSelectionChange($event, center)" class="form-check-input border-radius-5 cursor-pointer" />
                  <div>
                    <div class="fw-semibold">{{ center.CenterName }} ({{ center.State }})</div>
                    <!-- <div class="fs-12">{{ center.Address }}</div> -->
                  </div>
                </label>
                }
              </div>

              <div class="popup-actions p-2 text-end">
                <button class="btn btn-primary btn-sm" (click)="applySelection()">Apply</button>
              </div>
            </div>
            }
          </div>
          } @else {
          <img src="public/spartan.png" alt="spartan logo" routerLink="/center-select-page" class="cursor-pointer" />
          }
        </div>

        <div *ngIf="isLoggedIn && showSideBar && router.url !== '/center-select-page'">
          <button routerLink="/center-select-page" class="dashboard-primary font-white border-radius-5 fs-14 py-2 px-2 fw-medium cursor-pointer mt-1 me-5">Go to Dashboard</button>
        </div>
      </div>

      <div class="col-6 d-flex justify-content-between position-relative">
        <div class="d-flex align-items-center gap-2 position-relative">
          @if (isLoggedIn && showSideBar) {
          <button class="create-btn" (click)="toggleDropdown($event)" (keydown)="toggleDropdown($event)" tabindex="0">
            Create
            <span [innerHtml]="SVG_ICONS.STRAIGHT_LINE() | sanitizer : 'html'" class="ms-2"></span>
            <span [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'" class="ms-2"></span>
          </button>
          } @if (isDropdownOpen) {
          <div
            class="dropdown-box position-absolute z-2 border-radius-10 shadow mt-4"
            (click)="$event.stopPropagation()"
            role="menu"
            aria-labelledby="profile-menu"
            tabindex="-1"
            (keydown)="$event.stopPropagation()"
            (click)="$event.preventDefault()">
            <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('student/add-student')" type="button" tabindex="0">
              <span [innerHtml]="SVG_ICONS.ADD_MEMBER_ICON() | sanitizer : 'html'"></span>
              Add Student
            </button>

            @if(userTypeID === 1 || userTypeID === 2) {
            <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('coach/add-coach')" type="button" tabindex="0">
              <span [innerHtml]="SVG_ICONS.CLASS_ICON('#F5F5F5') | sanitizer : 'html'"></span>
              Add Coach
            </button>
            }
            <button class="dropdown-item w-100" (click)="navigateAndCloseDropdown('class-list/add-class')" type="button" tabindex="0">
              <span [innerHtml]="SVG_ICONS.CREATE_CLASS_ICON() | sanitizer : 'html'"></span>
              Create Class
            </button>
          </div>
          }
        </div>

        @if(isLoggedIn && showSideBar) {
        <div class="d-flex align-items-center gap-2 me-5 position-relative" (click)="closeAllDropdownsExcept('profile')" tabindex="0" (keydown)="toggleProfileDropdown($event)">
          <!-- <div [innerHtml]="SVG_ICONS.BELL_ICON() | sanitizer : 'html'"></div> -->
          <img
            [src]="profileImage"
            alt="profile"
            class="profile-img profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white"
            (error)="onImgError($event)" />

          <div class="font-white fw-bold fs-14 mt-3">
            {{ userDetails?.TrainerName }} {{ userDetails?.TrainerLastName || "" }}
            <p class="font-white fs-12 fw-normal">{{ userDetails?.Email || "" }}</p>
          </div>
          <span
            [innerHtml]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'"
            class="cursor-pointer"
            (click)="toggleProfileDropdown($event)"
            (keydown)="toggleProfileDropdown($event)"
            tabindex="0"
            aria-label="Toggle profile menu"></span>

          <div
            class="position-absolute top-100 end-0 bg-white border border-radius-10 mt-2 py-2 shadow profile-dropdown"
            *ngIf="isProfileDropdownOpen"
            style="min-width: 150px; z-index: 999"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            role="menu"
            aria-labelledby="profile-menu"
            tabindex="-1">
            <button class="dropdown-item px-3 py-2 d-block text-dark cursor-pointer" (click)="logout()" type="button" tabindex="0">Logout</button>
          </div>
        </div>
        }
      </div>
      }
    </div>

    <!-- Main Content (router-outlet renders here) -->
    <main class="h-100 bg-main-container container-fluid font-white" [class.login-page]="isLoginPage">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
